import { AuthorizationService } from '@app/security/shared/authorization.service';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageRefService } from '@app/shared/services/browser/local-storage-ref.service';
import { Logger } from '@app/logger/logger';
import { Observable } from 'rxjs';
import { SecurityService } from '@app/security/shared/security.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(
    private authorizationService: AuthorizationService,
    private localStoreageServcie: LocalStorageRefService,
    private logger: Logger,
    private securityServcie: SecurityService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      headers: request.headers.set('seat_token', this.localStoreageServcie.seatToken)
    });

    return next.handle(request).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.logger.log(
                'Received a 401 from the server, logging user out',
                request,
                err,
                '\t(unauthorized.interceptor.ts)'
              );
              this.securityServcie.forceLogout();
            } else if (err.status === 403) {
              this.authorizationService.displayInsufficientPermissionDialog(err.url);
              this.logger.log(
                'Received a 403 from the server',
                request,
                err,
                '\t(unauthorized.interceptor.ts)'
              );
            }

            return;
          }
        }
      )
    );
  }
}
